import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from 'lucide-react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '@/app/theme';

/** Уведомления. Тему берут из собственного провайдера, а не из next-themes. */
const Toaster = ({ ...props }: ToasterProps) => {
  const { resolved } = useTheme();

  return (
    <Sonner
      theme={resolved}
      className="toaster group"
      position="bottom-right"
      // Три секунды: хватает прочитать строку и не хватает, чтобы уведомление
      // начало мешать. Ошибки живут дольше — их задаёт вызывающая сторона.
      duration={3000}
      // pos-toast поднимает избирательность над правилом самой библиотеки и
      // приводит появление к общему для приложения времени. Без класса
      // пришлось бы бить !important по чужому стилю.
      toastOptions={{ className: 'pos-toast' }}
      // Иконка различает тип быстрее подписи, цвет — быстрее иконки.
      // Вместе они дают ответ до чтения текста, а порознь каждый признак
      // остаётся проверяемым: цвет не единственный носитель смысла.
      icons={{
        success: <CircleCheckIcon className="size-4 text-tone-success" />,
        info: <InfoIcon className="size-4 text-tone-progress" />,
        warning: <TriangleAlertIcon className="size-4 text-tone-warning" />,
        error: <OctagonXIcon className="size-4 text-tone-danger" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
